import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { type GeneralSmartParkError } from 'src/types';
import { formatResourcePath } from 'src/utils/regex';

import type { AllowListMemberFormSchemaValues } from 'src/features/parkingManagement/api/AllowListAPI/useCreateAllowListMember';
import type { AllowListMember } from 'src/features/parkingManagement/types/allowList';

export type MutationFnType = typeof mutationFn;

const RESOURCE = '/parkings/:parkingId/allow-list/:listId/allow-list-member/:memberId/';

export interface DTO extends AllowListMemberFormSchemaValues {
    parkingId: string;
    listId: string;
    memberId: string;
}

const mutationFn = ({ parkingId, listId, memberId, ...data }: DTO): Promise<AllowListMember> => {
    return axios.patch(formatResourcePath(RESOURCE, { parkingId, listId, memberId }), data);
};

interface UseCreateAdditionalServicesOptions extends MutationConfig<MutationFnType, GeneralSmartParkError> {}

export const useMutationHook = (options: UseCreateAdditionalServicesOptions) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateAllowListMember };
